import { Toaster as Sonner } from 'sonner';

/** App-wide toast host (sonner). Themed to the Ingazi tokens; mounted once at the
 *  root so any feature can call `toast(...)`. */
export function Toaster() {
  return (
    <Sonner
      position="top-right"
      toastOptions={{
        classNames: {
          toast: 'rounded-lg border bg-card text-card-foreground shadow-lg',
          description: 'text-muted-foreground',
          actionButton: 'bg-primary text-primary-foreground',
          // Panel allocation reports outcomes that are neither success nor
          // failure — it placed the applications AND left three unplaced. Those
          // need to look different from the success beside them; without this
          // they inherit the neutral card and read as confirmation.
          warning: 'border-amber-500/40 bg-amber-500/5 text-amber-700 dark:text-amber-400',
        },
      }}
    />
  );
}
